export default __webpack_public_path__ + "static/media/generate.009eb23d.svg";